module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"document-title":"Damage calculator","attacker":"Attacker","defender":"Defender","pick":"Pick"},"ru":{"document-title":"Калькулятор урона","attacker":"Атакующий","defender":"Защищающийся","pick":"Выбрать"}}')
  delete Component.options._Ctor
}
